import { useQuery } from "@tanstack/react-query";
import type { EmailMessageRecipientDTO } from "../../types/dtos/EmailMessageRecipientDTO";
import { emailKeys } from "@repo/types/queries";
import { useApiAccess } from "@repo/hooks/contexts";

export function useGetEmails(keywords: string) {
  const { apiClient } = useApiAccess();

  return useQuery({
    queryKey: emailKeys.list(keywords),
    queryFn: async () => {
      const response = await apiClient.get<EmailMessageRecipientDTO[]>(
        `/Search/GetEmails?keywords=${keywords}`,
      );
      return response.data;
    },
  });
}
